module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.3d2d1385.woff";